import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useAuth } from "../../AuthContext";
import { useAppKitAccount } from "@reown/appkit/react";
import { createAppKit } from "@reown/appkit";
import {mainnet, solana } from "@reown/appkit/networks";
import { SolanaAdapter } from "@reown/appkit-adapter-solana/react";
import { PhantomWalletAdapter } from "@solana/wallet-adapter-phantom";
import { SolflareWalletAdapter } from "@solana/wallet-adapter-wallets";
import { EthersAdapter } from "@reown/appkit-adapter-ethers";
require("@solana/wallet-adapter-react-ui/styles.css");

const shortenAddress = (address) => {
  return address ? `${address.slice(0, 4)}...${address.slice(-4)}` : "";
};

function Header() {
  const { logout, wallet_address, authenticated } = useAuth();
  const { address, isConnected } = useAppKitAccount();
  const modelRef=useRef(null)
  const settings = {
    dots: false,
    infinite: true,
    speed: 20000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 10,
    cssEase: "linear",
    centerMode: false,
    arrows: false,

    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  useEffect(() => {
    if(!modelRef.current){
      const solanaWeb3JsAdapter = new SolanaAdapter({
        wallets: [new PhantomWalletAdapter(), new SolflareWalletAdapter()],
      });
      const projectId = "6c9760534aa3c822cb8a072339bbca59";
    
      // 2. Create a metadata object - optional
      const metadata = {
        name: "AppKit",
        description: "AppKit Solana Example",
        url: "https://example.com", // origin must match your domain & subdomain
        icons: ["https://avatars.githubusercontent.com/u/179229932"],
      };
       modelRef.current = createAppKit({
        adapters: [solanaWeb3JsAdapter,new EthersAdapter()],
        networks: [solana,mainnet],
        metadata: metadata,
        projectId,
        features: {
          analytics: true, // Optional - defaults to your Cloud configuration
        },
      });
    
    }
  }, [])
  
  useEffect(() => {
    if (authenticated && wallet_address) {
      const checkConnection = () => {
        if (!isConnected) {
          logout();
          window.location.href = "/";
        } else if (address !== wallet_address) {
          logout();
          window.location.href = "/";
        }
      };
      const timeout = setTimeout(checkConnection, 3000);
      return () => clearTimeout(timeout);
    }
  }, [address, isConnected, wallet_address, authenticated, logout]);

  return (
    <>
      <div className="top_fix">
        <div className="container-fluid">
   
         <Slider {...settings}>
            <div
              data-aos="fade-up"
              style={{ margin: "0 10px", display: "inline-block" }}
            >
              <p className="mb-0 white-space-p">
                EXCLUSIVE BONUSES FOR SCOTTY ON ETH HOLDERS - BUY SCOTTY ON
                SOLANA TO FIND OUT IF YOU ARE ELIGIBLE
              </p>
            </div>
            <div
              data-aos="fade-up"
              style={{ margin: "0 10px", display: "inline-block" }}
            >
              <p className="mb-0 white-space-p">
                EXCLUSIVE BONUSES FOR SCOTTY ON ETH HOLDERS - BUY SCOTTY ON
                SOLANA TO FIND OUT IF YOU ARE ELIGIBLE
              </p>
            </div>
          </Slider>  
        </div>
      </div>
      <nav className="navbar navbar-expand-lg nav_fix  ps-md-3">
        <div className="container-fluid">
          <Link className="navbar-brand" to="/">
            {" "}
            <img src="/assets/img/logo.svg" alt="Logo" />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapsibleNavbar"
          >
            <i className="bi bi-list"></i>
          </button>
          <div className="collapse navbar-collapse " id="collapsibleNavbar">
            <ul className="navbar-nav ms-md-4 me-md-auto">
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="https://scotty-the-ai-on-solana.gitbook.io/scotty-the-ai-on-solana"
                  target="_blank"
                >
                  Whitepaper
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/#tokenomics">
                  Tokenomics
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/#roadmap">
                  Roadmap{" "}
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="https://app.solidproof.io/projects/scotty-ai"
                  target="_blank"
                >
                  Audit{" "}
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="https://www.mexc.com/exchange/SCOTTYV2_USDT"
                  target="_blank"
                >
                  Trade Now{" "}
                </a>
              </li>
            </ul>
          </div>
          <div className="right_btn">
            <a
              href="https://x.com/ScottyThe_Ai"
              className="btn btn_border"
              target="_blank"
            >
              {" "}
              <img src="/assets/img/t2.svg" alt="t2" />
            </a>
            <a
              href="https://t.me/SCOTTY_Ai"
              className="btn btn_border"
              target="_blank"
            >
              {" "}
              <img src="/assets/img/t4.svg" alt="t4" />
            </a>

            <div className="">
              {/* <WalletMultiButton className="bg-orange-500 text-white rounded-lg hover:bg-orange-600">
                {connected
                  ? shortenAddress(publicKey.toBase58())
                  : "Connect Phantom Wallet"}
              </WalletMultiButton> */}
              {/* <button
                onClick={() => {
                  modelRef.current.open();
                }}
                className="btn  btn_bg header-connect-btn"
              >
                {isConnected
                  ? shortenAddress(address)
                  : "Connect Wallet"}
              </button> */}

                <button
                onClick={() => {
                  modelRef.current.open();
                }}
                className="btn  btn_bg header-connect-btn"
              >
                {isConnected
                  ? shortenAddress(address)
                  : "Connect Wallet"}
              </button>

              {/* <WalletMultiButton/> */}
            </div>
            {/* {address && (
              <div className="btn btn_bg header-connect-btn">
                <WalletDisconnectButton />
              </div>
            )} */}

            {/* <Link to="/" className="btn_border2 ms-2 d-flex align-items-center"> 
              <span className="me-2 d-flex align-items-center"> 
                <img className="me-2" src="/assets/img/en.png" alt="t4" /> En
              </span>
              <i className="bi bi-chevron-down"></i>
            </Link> */}
          </div>
        </div>
      </nav>
    </>
  );
}

export default Header;
